import React from "react";
import PropTypes from "prop-types";
import ConnectedEventProfileImage from "../../../../common/EventProfileImage";

import "./RegistrationHeader.scss";

const RegistrationHeading = ({ renderHeading }) => <>{renderHeading()}</>;

RegistrationHeading.propTypes = {
    renderHeading: PropTypes.func.isRequired,
};

const RegistrationHeader = ({
    additionalText = "",
    displayEventDate,
    formattedDateString = "",
    hasDate,
    isMediumScreen,
    renderHeading,
}) => (
    <header className="registration-header -margin-bottom--10">
        {/* eslint-disable-next-line tailwindcss/classnames-order */}
        <div className="grid grid--justify-content-center">
            <div className="col col--md-10 col--sm-12 col--no-top-gutter">
                {!isMediumScreen && (
                    <div className="-margin-bottom--10">
                        <ConnectedEventProfileImage />
                    </div>
                )}
                <RegistrationHeading renderHeading={renderHeading} />
                {additionalText && (
                    <p className="-text--center">{additionalText}</p>
                )}
                {hasDate && displayEventDate && (
                    <p className="registration-header__p -text--center">
                        <small>{formattedDateString}</small>
                    </p>
                )}
            </div>
        </div>
    </header>
);

RegistrationHeader.propTypes = {
    additionalText: PropTypes.string,
    formattedDateString: PropTypes.string,
    displayEventDate: PropTypes.bool.isRequired,
    hasDate: PropTypes.bool.isRequired,
    isMediumScreen: PropTypes.bool.isRequired,
    renderHeading: PropTypes.func.isRequired,
};

export default RegistrationHeader;
